/**
 * Golf Tournament List Reducers
 */
import {
    TOURNAMENTLIST_ACTION,
    ALL_TOURNAMENTLIST,
    ADD_TOURNAMENTLIST,
    FETCH_TOURNAMENTLIST,
    EDIT_TOURNAMENTLIST,
    DELETE_TOURNAMENTLIST
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    tournamentalllist:[],
    detailstournamentlist:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case TOURNAMENTLIST_ACTION:
            return { ...state, loading: true };       

        case ALL_TOURNAMENTLIST:
            return { ...state, loading: false, tournamentalllist: action.payload };     
            
        case ADD_TOURNAMENTLIST:
            return { ...state, loading: false };     
         
        case FETCH_TOURNAMENTLIST:
            return { ...state, loading: false, detailstournamentlistl: action.payload };  
            
        case EDIT_TOURNAMENTLIST:
            return { ...state, loading: false }; 
            
        case DELETE_TOURNAMENTLIST:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }